import React from 'react'
import { Link } from 'react-router-dom'
import Footer from '../components/Footer'
import Header from '../components/Header'
import { itemsFetchPostsByCategory } from '../actions/index'
import { connect } from 'react-redux'
import RightArrow from '../images/tail-right.svg'


class PostList extends React.Component {

    componentDidMount() {
        this.props.fetchData(this.props.activeCategory._id)
    }

    renderLoadingMessage = () => {
      if (this.props.hasErrored) {
        return <p>Sorry! There was an error loading the items</p>;
        }
        if (!this.props.posts.length && this.props.isLoading) {
        return (
        <div className="spinner">
          <div className="bounce1"></div>
          <div className="bounce2"></div>
          <div className="bounce3"></div>
        </div>
        )
      }
    }

    


    render() {


    return(

        

      <div>
        <Header />

        

        <div className="container">

          <h1 style={{marginTop: 0, textAlign: 'center'}}>Topics for {this.props.activeCategory._id}</h1>

          <Link to="/new-topic"><button style={{display: 'block', margin: 'auto', marginBottom: 40}} className="purple-button">Add new topic</button></Link>

          {this.renderLoadingMessage()}

          {this.props.posts.map( post => 
          <Link style={{textDecoration: 'none'}} to={"/post/" + post._id} className="post-item" key={post.id}>
          <div>
            <p className="post-item-name" style={{textAlign: 'left'}}>{post.title}</p>
            <p style={{fontSize: 14, color: 'black'}} className="post-item-date">Created on {post.date}</p>
          </div>
                
                
          <img alt="" style={{ width: 30, paddingRight: 20 }} src={RightArrow} />
          
          </Link> )}

        </div>

        <Footer />

      </div>
    )
  }
}

const mapStateToProps = (state) => {
    return {
        posts: state.posts,
        hasErrored: state.itemsHasErrored,
        isLoading: state.itemsIsLoading,
        activeCategory: state.activeCategory
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: (category) => dispatch(itemsFetchPostsByCategory(category))
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(PostList)




// WEBPACK FOOTER //
// ./src/components/PostList.js